import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_COMMUNICATION } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDolCommunicationState extends EntityState<IID_OL_COMMUNICATION, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_COMMUNICATION })
export class IIDolCommunicationStore extends EntityStore<IIDolCommunicationState> {
  constructor() {
    super([]);
  }
}
